import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'ActionAreaContainer' })((theme) => ({
  actionAreaContainer: {
    display: 'flex',
    padding: theme.spacing(4, 2, 2, 2),
    width: '100%',
    gap: theme.spacing(2),
  },
  alignRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  alignColumn: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  alignRowReverse: {
    flexDirection: 'row-reverse',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  alignColumnReverse: {
    flexDirection: 'column-reverse',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export default useStyles;
